import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/home";

const anchors = [
  { label: "今日热榜", to: "#hot" },
  { label: "事件合集", to: "#collections" },
  { label: "大事件时间线", to: "#timeline" },
  { label: "精选解读", to: "#featured" },
  { label: "常见问题", to: "#faq" },
];

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20crimson%20and%20amber%20smoke%20swirling%20in%20shadow%2C%20dramatic%20theatrical%20lighting%2C%20moody%20editorial%20cinematic%20background%2C%20no%20people%2C%20no%20text&width=1800&height=1100&seq=hero-kedou-01&orientation=landscape"
          alt="蝌蚪黑料热门事件追踪平台氛围背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/90"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pb-10 md:pb-14 pt-32 md:pt-40">
        <div className="max-w-content mx-auto w-full">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/25 border border-primary-400/40 text-primary-100 text-xs md:text-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></span>
            全网热门瓜料持续更新中
          </span>

          <h1 className="mt-5 font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight max-w-3xl">
            蝌蚪黑料
            <span className="block mt-2 text-xl md:text-3xl lg:text-4xl font-bold text-accent-300">
              热门事件合集与瓜料追踪
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-100">
            把热门事件、劲爆消息按话题归到不同版块，点开就能看到完整瓜料、精华梳理和持续更新。
            适合想吃热瓜又怕漏掉后续的人。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/collections"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-fire-line"></i>
              进入事件合集
            </Link>
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50/10 border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-history-line"></i>
              查看大事件时间线
            </a>
          </div>

          <div className="mt-9 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl">
            {siteStats.map((s) => (
              <div key={s.label} className="border-l-2 border-primary-500 pl-3">
                <p className="font-heading text-xl md:text-2xl font-bold text-background-50">
                  {s.value}
                </p>
                <p className="text-xs md:text-sm text-background-200 mt-0.5">{s.label}</p>
              </div>
            ))}
          </div>

          <nav className="mt-9 flex flex-wrap items-center gap-2 md:gap-3">
            {anchors.map((a) => (
              <a
                key={a.to}
                href={a.to}
                className="px-3.5 py-2 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs md:text-sm hover:bg-accent-500 hover:text-foreground-950 hover:border-accent-500 transition-colors whitespace-nowrap"
              >
                {a.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </section>
  );
}